"use client";

import { RequestProgram } from "@/app/(main)/voyage/[aliasId]/_components/RequestProgram";
import { requestProgrammeOnSuccessSearch } from "@/app/(main)/voyage/[aliasId]/_components/RequestProgram/requestProgrammeOnSuccessSearch";
import type { Countries } from "@/queries/getCountries";
import type { SearchDeparture, SearchTravel } from "front-search-schema/algolia";
import { ThirdButton } from "ui/components";
import { DownloadIcon } from "ui/iconsN";

type Props = {
  travel: SearchTravel;
  departure: SearchDeparture;
  countries: Countries;
};

export const RequestProgramClient = ({ travel, departure, countries }: Props) => {
  return (
    <RequestProgram
      isAvailable={departure.state.versionStatus !== "soon"}
      travelId={travel.id}
      versionId={departure.versionId}
      departureId={departure.id}
      onSuccess={() => requestProgrammeOnSuccessSearch(travel, departure)}
      countries={countries}
      travelTitle={travel.title}
      travelImage={travel.travelImages[0] || null}
      departure={departure}
      travelCountries={travel.destinationAliases.slice(0, 1).map((alias) => ({ title: "", alias }))}
      source="side"
      className="hidden @xl/side:block"
    >
      <ThirdButton size="sm">
        <DownloadIcon className="shrink-0 text-pr-1" />
        Télécharger le programme complet
      </ThirdButton>
    </RequestProgram>
  );
};
